import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";
import globalslice from './globalslice';
import orderslice from './orderslice'

// API Key

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    globalslice:globalslice,
    orderslice:orderslice,
});

export default rootReducer;